import { render, staticRenderFns } from "./FilesContainer.vue?vue&type=template&id=2e5a174a"
import script from "./FilesContainer.vue?vue&type=script&lang=js"
export * from "./FilesContainer.vue?vue&type=script&lang=js"
import style0 from "./FilesContainer.vue?vue&type=style&index=0&id=2e5a174a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports